export const STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const STATUS_RELEASED = 'RELEASED';

export const BENCHMARK_STATUSES = [STATUS_IN_PROGRESS, STATUS_RELEASED];
